import { render, staticRenderFns } from "./literatureDetail.vue?vue&type=template&id=f6349b64&scoped=true&"
import script from "./literatureDetail.vue?vue&type=script&lang=js&"
export * from "./literatureDetail.vue?vue&type=script&lang=js&"
import style0 from "./literatureDetail.vue?vue&type=style&index=0&id=f6349b64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6349b64",
  null
  
)

export default component.exports